<script>
import LoginForm from "./login-form.vue";
import LoginWindow from "./login-window.vue";
import LoginFooterIcons from "./login-footer-icons.vue";
import LoginSubmitButton from "./login-submit-button.vue";
import LoginContainer from "./login-container.vue";
import LoginBanner from "./login-banner.vue";
import Loading from "../common/loading.vue";
import LoginEmailField from "./login-email-field.vue";
import LoginWindowFooter from "./login-window-footer.vue";
import LoginPasswordField from "./login-password-field.vue";
import TextField from "../common/text-field.vue";
import LoginStringField from "./login-string-field.vue";

export default {
    name: "register",
    components: {
        LoginStringField,
        TextField,
        LoginPasswordField,
        LoginWindowFooter,
        LoginEmailField,
        Loading,
        LoginBanner,
        LoginContainer,
        LoginSubmitButton,
        LoginFooterIcons,
        LoginWindow,
        LoginForm
    },
    props: {
        loginUrl: String,
        versionText: String,
        csrfToken: String,
        success: String,
        activated: String,
        activatedPreviously: String
    },
    data() {
        return {
            emailValid: false,
            firstnameValid: false,
            lastnameValid: false,
            productkeyValid: false,
            loading: false,
        }
    },
    provide() {
        return {
            appKey: this.appKey,
        }
    },
    computed: {
        translations() {
            return {
                demo: Lang.langGet('Demo'),
                register: Lang.langGet('Register'),
                forgotPw: Lang.langGet('Forgot password'),
                email: Lang.langGet('Email address'),
                password: Lang.langGet('Password'),
                login: Lang.langGet('Login'),
                firstName: Lang.langGet('First name'),
                lastName: Lang.langGet('Last name'),
                productKey: Lang.langGet('Product key'),
                registrationSuccess: Lang.langGet("The registration was successful. Check your inbox, you should have received an email. There, you can set your password."),
                activated: Lang.langGet("The user was activated successfully. You can close this window."),
                activatedPreviously: Lang.langGet("The user has already been activated previously! You can close this window."),
                subTitle: Lang.langGet('Create, design and publish your digital signage content with a few clicks!')
            }
        },
        subTitle() {
            if (this.success) return this.translations.registrationSuccess;
            if (this.activated) return this.translations.activated;
            if (this.activatedPreviously) return this.translations.activatedPreviously;
            return this.translations.subTitle;
        }
    },
    methods: {
        handleSubmit() {
            this.loading = true;
        },
        handleValidity(prop, value) {
            this[`${prop}Valid`] = value;
        }
    }
}
</script>

<template>
    <login-container>
        <loading :loading="loading"/>
        <login-window>
            <login-banner :subTitle="subTitle" />

            <login-form v-if="!success && !activated && !activatedPreviously">
                <input type="hidden" name="_token" :value="csrfToken" autocomplete="off" />
                <login-string-field autofocus @valid="handleValidity" property="firstname" autocomplete="given-name" :label="translations.firstName" />
                <login-string-field @valid="handleValidity" property="lastname" autocomplete="family-name" :label="translations.lastName" />
                <login-email-field :autofocus="false" @valid="handleValidity" />
                <login-string-field @valid="handleValidity" property="productkey" placeholder="XXXXX-XXXXX-XXXXX-XXXXXX-XXXXXX" :label="translations.productKey" />
                <login-submit-button @click="handleSubmit" :disabled="!emailValid || !firstnameValid || !lastnameValid || !productkeyValid">
                    {{ translations.register }}
                </login-submit-button>
            </login-form>

            <login-window-footer :versionText="versionText">
                <a :href="loginUrl" class="">{{ translations.login }}</a>
            </login-window-footer>
        </login-window>
        <login-footer-icons url="https://easescreen.com/"/>
    </login-container>
</template>
